Components.WorkspaceExamplePromo = {
    bindings: {
        onClick: '&',
    },
    // @ngInject
    controller: function WorkspaceExamplePromoController($, $scope, $location, $window, DeviceService, PopupMessageService, AppStates, AnalyticsService) {
        this.PopupMessageService = PopupMessageService;
        this.AppStates = AppStates;
        this.AnalyticsService = AnalyticsService;

        this.$onInit = function $onInit() {
            this.isMobile = DeviceService.checkIfMobileSize();
            this.iconSrc = $.cloudinary.url(
                'app/modules/core/features/registration/header_promo_animation.gif', {secure: true});
            this.iconSrc2x = $.cloudinary.url(
                'app/modules/core/features/registration/header_promo_animation_2x.gif', {secure: true});
        };
        this.$close = function $close() {
            this.PopupMessageService.showConfirm(this.PopupMessageService.severityTypes.info, "Before you go, would you like to get a glimpse at the full product?",
                function clickedYeah() {
                    this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.example_proposal_promo_close_keep_exploring);
                    $location.path("/app");
                }.bind(this),
                function clickedNay() {
                    this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.example_proposal_promo_close_no_thanks);
                    $window.location.href = location.protocol + "//" + $window.location.host;
                }.bind(this),
                "Keep Exploring",
                "No Thanks");
        };
    },
    templateUrl: 'angular/app/modules/core/features/workspace_file/promo/workspace_example_promo.html',
};
